import { pilot } from '~/services/serviceInstances';

interface Request {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export const updatePassword = ({
  currentPassword,
  newPassword,
  confirmNewPassword,
}: Request) => {
  const response = pilot.put('/user/change-password/', {
    current_password: currentPassword,
    new_password: newPassword,
    verify_new_password: confirmNewPassword,
  });
  console.log('response', response);
  return response;
};
